<template>
  <div :class="['message', image || video ? 'message--media' : '']">
    <Lightbox v-if="image" :image="image" />
    <Lightbox
      v-else-if="video"
      :video="video"
      :messages="messages"
      :wasPlayedEarlier="wasPlayedEarlier"
    />
    <slot v-else></slot>
  </div>
  <!-- / message -->
</template>

<script>
import Lightbox from "@/components/Lightbox.vue";

export default {
  name: "Message",
  components: {
    Lightbox
  },
  props: {
    wasPlayedEarlier: Boolean,
    messages: Array,
    image: String,
    video: Object
  }
};
</script>

<style lang="scss">
.message {
  // box-shadow: 0px 3px 13px 0 rgba($txt-color, 0.1);
  background-color: $color-bg-message-box;
  font-family: $font-main;
  letter-spacing: 0.4px;
  border-radius: 20px;
  margin-bottom: 10px;
  padding: 13px 15px;
  color: $txt-color;
  overflow: hidden;
  line-height: 1.4;
  font-weight: 400;
  max-width: 220px;
  font-size: 10px;

  @media #{$bigger-mobile} {
    font-size: 13px;
  }

  &--media {
    width: 45vw;
    padding: 0;
  }
}
</style>
